import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceUp4.vue?vue&type=template&id=6376db5e&"
import script from "./FaceDirectionResultEffectFaceUp4.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceUp4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports